var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "send-email-config" },
    [
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.senderFrom")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "show-search": "",
                placeholder: _vm.$t("taskModuleRules.selectSenderEmail"),
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.from,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "from", $$v)
                },
                expression: "localConfig.from",
              },
            },
            _vm._l(_vm.senderMails, function (mail) {
              return _c(
                "a-select-option",
                { key: mail.mail, attrs: { value: mail.mail } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(mail.mail) +
                      " (" +
                      _vm._s(_vm.getMailLabel(mail)) +
                      ")\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("taskModuleRules.recipientTypeTo"))),
          ]),
          _vm._v(" "),
          _c(
            "a-radio-group",
            {
              attrs: { "button-style": "solid" },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.toType,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "toType", $$v)
                },
                expression: "localConfig.toType",
              },
            },
            [
              _c("a-radio-button", { attrs: { value: "static" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.staticEmail"))),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.dynamic"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localConfig.toType === "static"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("taskModuleRules.recipientEmailAddresses"))
                ),
              ]),
              _vm._v(" "),
              _c("a-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  mode: "tags",
                  placeholder: _vm.$t("taskModuleRules.enterEmailAddresses"),
                },
                on: { change: _vm.emitChange },
                model: {
                  value: _vm.localConfig.toStatic,
                  callback: function ($$v) {
                    _vm.$set(_vm.localConfig, "toStatic", $$v)
                  },
                  expression: "localConfig.toStatic",
                },
              }),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  _vm._s(
                    _vm.$t("taskModuleRules.youCanEnterEmailsSeparatedByComma")
                  )
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.localConfig.toType === "dynamic"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.dynamicRecipients"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    mode: "multiple",
                    placeholder: _vm.$t(
                      "taskModuleRules.selectDynamicRecipient"
                    ),
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.toDynamic,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "toDynamic", $$v)
                    },
                    expression: "localConfig.toDynamic",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "task_owner" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.taskOwner"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_assignees" } },
                    [_vm._v(_vm._s(_vm.$t("taskModuleRules.taskAssignees")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_followers" } },
                    [_vm._v(_vm._s(_vm.$t("taskModuleRules.taskFollowers")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_collaborators" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("taskModuleRules.taskCollaborators"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_relation_visitor" } },
                    [_vm._v(_vm._s(_vm.$t("taskModuleRules.relatedCustomer")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.ccOptional")))]),
          _vm._v(" "),
          _c("a-select", {
            staticStyle: { width: "100%" },
            attrs: {
              mode: "tags",
              placeholder: _vm.$t("taskModuleRules.ccEmailAddresses"),
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.cc,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "cc", $$v)
              },
              expression: "localConfig.cc",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.bccOptional")))]),
          _vm._v(" "),
          _c("a-select", {
            staticStyle: { width: "100%" },
            attrs: {
              mode: "tags",
              placeholder: _vm.$t("taskModuleRules.bccEmailAddresses"),
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.bcc,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "bcc", $$v)
              },
              expression: "localConfig.bcc",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "config-field" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.subjectSubject")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-input", {
              attrs: {
                placeholder: _vm.$t(
                  "taskModuleRules.emailSubjectWithDynamicVariables"
                ),
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "subject", $$v)
                },
                expression: "localConfig.subject",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("taskModuleRules.variables")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "config-field" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.contentBody")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-textarea", {
              attrs: {
                placeholder: _vm.$t(
                  "taskModuleRules.emailContentWithHtmlAndVariables"
                ),
                rows: 6,
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.body,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "body", $$v)
                },
                expression: "localConfig.body",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("taskModuleRules.variables")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(_vm._s(_vm.$t("taskModuleRules.youCanUseHtmlTags"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.showVariablesPicker
        ? _c("DynamicVariablesPicker", {
            attrs: { visible: _vm.showVariablesPicker },
            on: {
              close: function ($event) {
                _vm.showVariablesPicker = false
              },
              select: _vm.insertVariable,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }